export function sticky()
{
	window.onscroll = function changeClass(){
		let scroll = window.pageYOffset | document.body.scrollTop;

		let HIheight = document.querySelector('.headerimage').clientHeight;
		let BtnHeight = document.getElementById('menu-button').offsetHeight;

		if(scroll >= HIheight / 2 - BtnHeight / 2) {
			document.body.classList.add('sticky-menu');
		} else {
			document.body.classList.remove('sticky-menu');
		}
	}
}
